import React from 'react';
import { Container } from 'reactstrap';
import { withLayout } from './PuckLayout';

import formatIntl from './Common/formatIntl';
import SectionHeader from './Common/SectionHeader';

const HeadingInternal = {
  fields: {
    text: {
      type: 'text',
      get label() { return formatIntl('Header'); },
    },
    textSubheader: {
      type: 'text',
      get label() { return formatIntl('Subheader'); },
    },
    align: {
      type: 'radio',
      get label() { return formatIntl('Align'); },
      options: [
        { get label() { return formatIntl('Left'); }, value: 'left' },
        { get label() { return formatIntl('Center'); }, value: 'center' },
        { get label() { return formatIntl('Right'); }, value: 'right' },
      ],
    },
  },
  defaultProps: {
    align: 'left',
    text: formatIntl('Heading'),
    textSubheader: formatIntl('Subheading'),
    layout: {
      padding: '8px',
    },
  },
  render: ({
    align, text, textSubheader,
  }) => (
    <Container>
      <SectionHeader
        title={text}
        subtitle={textSubheader}
        align={align}
      />
    </Container>
  ),
};

export default withLayout(HeadingInternal);
